import { useEffect, useState } from 'react';
import { getPreNeedViewerInfo } from '~/api/NewViewer';
import { useFingerPrint } from '~/components/FingerPrintProvider';
export function useEmailOnlyForm(eventId) {
    const [loading, setLoading] = useState(true);
    const { country, fingerprint } = process.env.NODE_ENV === 'test'
        ? {
            country: 'NZ',
            fingerprint: 'mockFingerPrint',
        }
        : useFingerPrint();
    const [contactData, setContactData] = useState({
        fullName: '',
        oldEmail: '',
        email: '',
        country,
        mobile: '',
        zip: '',
    });
    const IS_USA = country === 'US';
    useEffect(() => {
        const verifyContactInfo = async () => {
            const verifyResponse = await getPreNeedViewerInfo(eventId, fingerprint);
            setContactData({
                fullName: verifyResponse.name,
                oldEmail: verifyResponse.email,
                email: verifyResponse.preferredEmail !== '' ? verifyResponse.preferredEmail : verifyResponse.email,
                country: verifyResponse.country ?? country,
                mobile: verifyResponse.phone,
                zip: verifyResponse.postcode,
            });
            setLoading(false);
        };
        verifyContactInfo();
    }, []);
    return {
        loading,
        setLoading,
        country,
        IS_USA,
        contactData
    };
}
